var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MixedCourseItemVimeo"},[_c('la-vimeo-player',{attrs:{"video-id":_vm.itemPreset.resource,"show":true,"seconds":_vm.seconds},on:{"time-tick":_vm.onTimeTick,"end-tick":_vm.onEndTick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }